"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var user = exports.user = {
  query: function query(userId) {
    return "/users/" + userId;
  },
  data: function data(userId) {
    return "data/users/" + userId;
  }
};
var charactersByUser = exports.charactersByUser = {
  data: function data(userId) {
    return "data/characters-by-user/" + userId;
  },
  query: function query(userId) {
    return {
      path: "/characters",
      storeAs: "/characters-by-user/" + userId,
      queryParams: ["orderByChild=user", "limitToFirst=5", "equalTo=" + userId]
    };
  }
};
var character = exports.character = {
  query: function query(charId) {
    return "/characters/" + charId;
  },
  data: function data(charId) {
    return "data/characters/" + charId;
  }
};
var options = exports.options = {
  query: function query(userId) {
    return "/options/" + userId;
  },
  data: function data(userId) {
    return "data/options/" + userId;
  }
};
var betaUsers = exports.betaUsers = {
  query: function query(userId) {
    return "/betaUsers/" + userId;
  },
  data: function data(userId) {
    return "data/betaUsers/" + userId;
  }
};
var betaKeyToUser = exports.betaKeyToUser = {
  query: function query(betaKey) {
    return "/betaKeyUsers/" + betaKey;
  },
  data: function data(betaKey) {
    return "data/betaKeyUsers/" + betaKey;
  }
};
var betaValidKeys = exports.betaValidKeys = {
  query: function query(betaKey) {
    return "/betaKeys/" + betaKey;
  },
  data: function data(betaKey) {
    return "data/betaKeys/" + betaKey;
  }
};
var appInfo = exports.appInfo = {
  query: function query() {
    return "/appInfo";
  },
  data: function data() {
    return "data/appInfo";
  }
};
var roles = exports.roles = {
  betaUsers: {
    query: function query(userId) {
      return "/userRoles/betaKeys/" + userId;
    },
    data: function data(userId) {
      return "data/userRoles/betaKeys/" + userId;
    }
  },
  prereleaseFlags: {
    query: function query(userId) {
      return "/userRoles/prereleaseFlags/" + userId;
    },
    data: function data(userId) {
      return "data/userRoles/prereleaseFlags/" + userId;
    }
  }
};
var connected = exports.connected = {
  query: function query() {
    return ".info/connected";
  },
  data: function data() {
    return "data//info/connected";
  }
};
var serverTimeOffset = exports.serverTimeOffset = {
  query: function query() {
    return ".info/serverTimeOffset";
  },
  data: function data() {
    return "data//info/serverTimeOffset";
  }
};
var rankings = exports.rankings = {
  query: function query(_ref) {
    var league = _ref.league,
        rankName = _ref.rankName;
    return {
      path: "/rankings/" + league + "/" + rankName,
      // Server-side sorting doesn't survive the trip to the client - dataToJS()
      // doesn't preserve sorting - and it won't matter once we switch to redis.
      // Need to for limit to work though.
      queryParams: ["orderByChild=value", "limitToFirst=100"]
    };
  },
  data: function data(_ref2) {
    var league = _ref2.league,
        rankName = _ref2.rankName;
    return "data/rankings/" + league + "/" + rankName;
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/firebase-connect/paths.js
// module id = 38
// module chunks = 0